var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "main-shadow",
    staticStyle: { "z-index": "-1" },
    style: _vm.styleInfo,
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }